import TabBar from './TabBar';

TabBar.install = function(Vue) {
    Vue.component(TabBar.name, TabBar);
};

export default TabBar;